import { ReactNode, useState } from "react";
import {
  ViewActionsSlotContext,
  ViewActionsSlotSetterContext,
} from "./context";

export const ViewActionsProvider = (props: {
  children: ReactNode;
}): JSX.Element => {
  const [slotEl, setSlotEl] = useState<HTMLElement | null>(null);

  // setSlotEl is referentially stable, so the setter consumer (TopHeader) never
  // re-renders when the node is registered — only the value consumer (the view)
  // re-renders, once, to fire its portal.
  return (
    <ViewActionsSlotSetterContext.Provider value={setSlotEl}>
      <ViewActionsSlotContext.Provider value={slotEl}>
        {props.children}
      </ViewActionsSlotContext.Provider>
    </ViewActionsSlotSetterContext.Provider>
  );
};
